"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Capitalizes the first character of each word in a string
 *
 * @category String
 * @param {string} value - The string to capitalize
 * @returns {string}
 * @example
 * capitalize('fox');
 * // => 'Fox'
 *
 * capitalize('the quick brown fox');
 * // => 'The Quick Brown Fox'
 */
var _default = function _default(value) {
  return value.replace(/(?:^|\s)\S/g, function (a) {
    return a.toUpperCase();
  });
};

exports.default = _default;